(function () {
  function parseCents(value) {
    const cents = Number.parseInt(value, 10);
    return Number.isFinite(cents) ? cents : 0;
  }

  function getTargetId(checkbox, attributeName) {
    return checkbox.getAttribute(attributeName) || "";
  }

  function setBlockDisplay(element, shouldShow) {
    if (!element) return;
    element.style.display = shouldShow ? "block" : "none";
  }

  function getBundleItemFromControl(control) {
    return control?.closest(".bundle_item") || null;
  }

  function getPreviewPriceElement(bundleItem) {
    if (!bundleItem) return null;
    return bundleItem.querySelector('[id^="preview_price-"]');
  }

  function getSelectedVariantPriceCents(bundleItem) {
    if (!bundleItem) return 0;

    const select = bundleItem.querySelector(".bundle_select");
    const selectedOption = select?.selectedOptions?.[0];
    if (selectedOption) {
      return parseCents(
        selectedOption.dataset.bundleVariantPriceCents ||
          selectedOption.getAttribute("data-bundle-variant-price-cents") ||
          selectedOption.dataset.bundleVariant ||
          selectedOption.textContent,
      );
    }

    const checkbox = bundleItem.querySelector(".bundle_checkbox_option");
    if (checkbox?.dataset?.productPriceCents) {
      return parseCents(checkbox.dataset.productPriceCents);
    }

    const quantityInput = bundleItem.querySelector(".quantity__input");
    return parseCents(quantityInput?.dataset?.bundlePriceCents);
  }

  function getBundleQuantity(bundleItem) {
    if (!bundleItem) return 1;
    const quantityInput =
      bundleItem.querySelector(
        "#bundle_variant_qty-" +
          bundleItem.dataset.bundleIndex +
          " .quantity__input",
      ) || bundleItem.querySelector(".quantity__input");
    const quantityValue = quantityInput
      ? Number.parseInt(quantityInput.value || "1", 10)
      : 1;
    return Number.isFinite(quantityValue) && quantityValue > 0
      ? quantityValue
      : 1;
  }

  function formatMoneyFromCents(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      const formattedMoney = window.Shopify.formatMoney(
        cents,
        window.money_format || "${{amount}}",
      );
      const tempWrapper = document.createElement("div");
      tempWrapper.innerHTML = formattedMoney;
      return (
        tempWrapper.textContent ||
        tempWrapper.innerText ||
        formattedMoney
      ).trim();
    }

    return `$${(cents / 100).toFixed(2)}`;
  }

  function updatePreviewPrice(bundleItem) {
    if (!bundleItem) return;

    const previewPriceElement = getPreviewPriceElement(bundleItem);
    if (!previewPriceElement) return;

    const selectedVariantPriceCents = getSelectedVariantPriceCents(bundleItem);
    const quantity = getBundleQuantity(bundleItem);
    const totalCents = selectedVariantPriceCents * quantity;

    previewPriceElement.dataset.currentPriceCents = String(totalCents);
    previewPriceElement.textContent = formatMoneyFromCents(totalCents);
  }

  function syncBundleRow(bundleItem) {
    if (!bundleItem) return;

    const checkbox = bundleItem.querySelector(".bundle_checkbox_option");
    if (!checkbox) return;

    const selectId = getTargetId(checkbox, "data-dropdown");
    const qtyId = getTargetId(checkbox, "data-qty");

    setBlockDisplay(document.getElementById(selectId), checkbox.checked);
    setBlockDisplay(document.getElementById(qtyId), checkbox.checked);

    if (checkbox.checked) {
      updatePreviewPrice(bundleItem);
      return;
    }

    const previewPriceElement = getPreviewPriceElement(bundleItem);
    if (!previewPriceElement) return;

    const originalPriceCents = parseCents(
      previewPriceElement.dataset.originalPriceCents,
    );
    previewPriceElement.dataset.currentPriceCents = String(originalPriceCents);
    previewPriceElement.textContent = formatMoneyFromCents(originalPriceCents);
  }

  function syncVariantSelection(selectEl) {
    const bundleItem = getBundleItemFromControl(selectEl);
    if (!bundleItem) return;

    const checkbox = bundleItem.querySelector(".bundle_checkbox_option");
    const selectedOption = selectEl?.selectedOptions?.[0];
    if (!checkbox || !selectedOption) return;

    checkbox.value = selectedOption.value;
    checkbox.dataset.productPriceCents = String(
      parseCents(
        selectedOption.dataset.bundleVariantPriceCents ||
          selectedOption.getAttribute("data-bundle-variant-price-cents"),
      ),
    );

    if (checkbox.checked) {
      updatePreviewPrice(bundleItem);
    }
  }

  function syncQuantityChange(quantityInput) {
    const bundleItem = getBundleItemFromControl(quantityInput);
    if (!bundleItem) return;

    if (quantityInput && Number.parseInt(quantityInput.value || "1", 10) < 1) {
      quantityInput.value = 1;
    }

    const checkbox = bundleItem.querySelector(".bundle_checkbox_option");
    if (checkbox && checkbox.checked) {
      updatePreviewPrice(bundleItem);
      return;
    }

    updatePreviewPrice(bundleItem);
  }

  function getSelectedBundleItems(bundleRoot = document) {
    const root = bundleRoot || document;
    const bundleItems = [];

    root.querySelectorAll(".bundle_item").forEach((bundleItem) => {
      const checkbox = bundleItem.querySelector(".bundle_checkbox_option");
      if (!checkbox || !checkbox.checked || !checkbox.value) return;

      const quantityInput = bundleItem.querySelector(".quantity__input");
      const quantity = Number.parseInt(quantityInput?.value || "1", 10);
      const variantId = Number.parseInt(checkbox.value, 10);

      if (!Number.isFinite(variantId) || variantId <= 0) return;

      bundleItems.push({
        id: variantId,
        quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
      });
    });

    return bundleItems;
  }

  function toggleBundleFields(checkbox) {
    if (!checkbox) return;

    const dropdownId = getTargetId(checkbox, "data-dropdown");
    const qtyId = getTargetId(checkbox, "data-qty");

    setBlockDisplay(document.getElementById(dropdownId), checkbox.checked);
    setBlockDisplay(document.getElementById(qtyId), checkbox.checked);

    syncBundleRow(checkbox.closest(".bundle_item"));
  }

  function initBundleDisplayToggles() {
    document.querySelectorAll(".bundle_checkbox_option").forEach((checkbox) => {
      toggleBundleFields(checkbox);

      if (checkbox.dataset.bundleToggleBound === "true") return;
      checkbox.dataset.bundleToggleBound = "true";

      checkbox.addEventListener("change", () => toggleBundleFields(checkbox));
    });

    document.querySelectorAll(".bundle_select").forEach((selectEl) => {
      if (selectEl.dataset.bundleSelectBound === "true") return;
      selectEl.dataset.bundleSelectBound = "true";
      selectEl.addEventListener("change", () => syncVariantSelection(selectEl));
      syncVariantSelection(selectEl);
    });

    document
      .querySelectorAll(".bundle_item .quantity__input")
      .forEach((quantityInput) => {
        if (quantityInput.dataset.bundleQuantityBound === "true") return;
        quantityInput.dataset.bundleQuantityBound = "true";
        quantityInput.addEventListener("input", () =>
          syncQuantityChange(quantityInput),
        );
        quantityInput.addEventListener("change", () =>
          syncQuantityChange(quantityInput),
        );
        syncQuantityChange(quantityInput);
      });
  }

  window.initBundleDisplayToggles = initBundleDisplayToggles;
  window.getSelectedBundleItems = getSelectedBundleItems;
  window.Bundle = window.Bundle || {};
  window.Bundle.getSelectedBundleItems = getSelectedBundleItems;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBundleDisplayToggles, {
      once: true,
    });
  } else {
    initBundleDisplayToggles();
  }
})();
